import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/depop-suspended-account';

export default function Example() {
  return (
    <>
      <Head>
        <title>Depop Account Suspended: Everything You Should Know to Avoid This</title>
        <meta
          name='description'
          content='Maintain a good seller reputation and avoid getting your Depop account suspended. Here are some tips to keep your account safe and your listings active.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/depop-suspended-account' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/depop-suspended-account' />
        <meta property='og:title' content='Depop Account Suspended: Everything You Should Know to Avoid This' />
        <meta
          property='og:description'
          content='Maintain a good seller reputation and avoid getting your Depop account suspended. Here are some tips to keep your account safe and your listings active.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-06-23T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-06-23T00:00:00-00:00' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
